import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import type { ClientType } from "types/DataTypes";

type InitialState = {
  currentClient: ClientType | null;
};

const clientSlice = createSlice({
  name: "client",
  initialState: {
    currentClient: null,
  } as InitialState,
  reducers: {
    setClient(state, action: PayloadAction<ClientType>) {
      state.currentClient = action.payload;
    },
  },
});

const { reducer } = clientSlice;

export const { setClient } = clientSlice.actions;

export default reducer;
